'use client';

import {
  Box,
  Collapse,
  freddyTheme,
  Link,
  SpriteIcon,
  Typography
} from '@coolblue-development/freddy';
import selectMoreProductInformationTrigger from '@coolblue-development/ga4-events/triggers/ProductInformation/selectMoreProductInformationTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { useTranslation } from '@i18n/useTranslation';

import { useProductInformation } from './ProductInformationContext';

const ProductDescription = ({
  description,
  hideLink = false
}: {
  description: string;
  hideLink?: boolean;
}) => {
  const { t } = useTranslation('webshop.productPage.productInformation');
  const { openModal } = useProductInformation();
  const { isMobile } = useBreakpoints();
  const collapseTranslations = useFreddyTranslations('collapse');
  const lineCount = isMobile ? 10 : 15;
  const { trackEvent } = useAnalytics();
  const params = {
    content: 'show more'
  };

  const handleLinkClick = () => {
    openModal();
    trackEvent(selectMoreProductInformationTrigger(params));
  };

  return (
    <Box>
      <Typography variant='h3' mb={200}>
        {t('description')}
      </Typography>
      <Collapse
        sx={{
          [freddyTheme.breakpoint.maxWidth('md')]: {
            'button[aria-controls^="collapse-content"]': {
              display: 'none'
            }
          }
        }}
        translations={collapseTranslations}
        onClick={() => {
          if (!isMobile) {
            trackEvent(selectMoreProductInformationTrigger(params));
          }
        }}
        collapsedLines={{ xs: !hideLink ? lineCount : undefined, md: lineCount }}
      >
        <Typography component='div' dangerouslySetInnerHTML={{ __html: description }} />
      </Collapse>
      {!hideLink && (
        <Link
          hideFrom='md'
          component='button'
          startIcon={<SpriteIcon name='arrow-right' />}
          onClick={handleLinkClick}
        >
          {t('fullDescription')}
        </Link>
      )}
    </Box>
  );
};

export default ProductDescription;
